import { simulatorData } from '~/components/slices/simulatorFuel/simulatorData'

export const calculateOutput = (
  contentfulData,
  selectedFuelType,
  enteredPrice,
  setAlertMessage,
  setOutput,
  setEquiv,
  setDistances,
  fuelType,
  lang,
) => {
  const { fuelDataGlobalConfiguration, section1Block3VehicleCategories } =
    contentfulData
  if (!fuelDataGlobalConfiguration) {
    console.error('No fuel data')
    setAlertMessage('Pas de données de carburant')
    return
  }
  const numPrice = parseFloat(enteredPrice)
  if (isNaN(numPrice)) {
    setAlertMessage('Veuillez entrer un nombre valide pour le prix')
    return
  }

  let tempOutput = []
  let newDistances = {}

  if (!fuelDataGlobalConfiguration[selectedFuelType]) {
    console.error(`No data for fuel type: ${selectedFuelType}`)
    setAlertMessage('Veuillez sélectionner un type de carburant valide')
    return
  }

  let conso = numPrice * fuelDataGlobalConfiguration[selectedFuelType].csvl

  Object.keys(fuelDataGlobalConfiguration).forEach((carb) => {
    const carbData = fuelDataGlobalConfiguration[carb]

    // Traduisez le libellé du carburant selon la langue sélectionnée
    // const translatedLib = simulatorData({ lang }).fuelDataGlobalConfiguration[
    //   carb
    // ].lib

    let parite = conso / carbData.csvl
    let euroMWh = parite * carbData.mwh

    if (carb === 'ELEC') {
      tempOutput.push({
        ...carbData,
        // lib: translatedLib,
        price: (Math.round(parite * 100) / 100).toFixed(2),
      })
    } else {
      tempOutput.push({
        ...carbData,
        // lib: translatedLib,
        price: (Math.round(parite * 10) / 10).toFixed(1),
      })
    }

    if (fuelType === carb) {
      setEquiv(Math.round(euroMWh / 10) * 10)
    }
  })

  Object.entries(section1Block3VehicleCategories).forEach(
    ([vehicleType, { consumptionRatio }]) => {
      const distance = (1000 / (conso * consumptionRatio)) * 100

      newDistances[vehicleType] = Math.floor(distance / 100) * 100
    },
  )

  setOutput(tempOutput)
  setDistances(newDistances)
}
